import { render, staticRenderFns } from "./outboundStudentChart.vue?vue&type=template&id=4ffa0ab7"
import script from "./outboundStudentChart.vue?vue&type=script&lang=js"
export * from "./outboundStudentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports